export default "__VITE_ASSET__BVP4E4Qi__";